export default __webpack_public_path__ + "static/media/student_loan_dark.0946e1a3.png";